/**
 * 发布找样
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/11      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React,{Fragment} from 'react';
import {Modal,Checkbox,Form,Input,Button,Select} from 'antd';
import SearchSelector from '@components/SearchSelector/SearchSelector';
import UploadImg from "../../Fuzzy/components/upload-img";
import Lang from "@components/Lang/Lang";
import "./index.less";
import request from "@utils/request";

class ReleaseFuzzy extends React.Component{
    constructor(props) {
        super(props);
        this.defaultState = {
            loading:false,
            visible:false,
            submitLoading:false,
            verify:false,
            fileIdList1:[],
            fileIdList2:[],
            subject:'',
            isAccurate:false,
            isNeedCertificate:false,
            purchaseQuantity:'',
            priceMax:'',
            accountSource:[],
            buyerAccountId:null,
            tradeCurrencySymbol:''
        }
        this.state = Object.assign({},this.defaultState);
    }

    /**
    * 切换显示
    **/
    changeVisible(visible){
        let state = {};
        if(visible){
           state = Object.assign({},this.defaultState);
        }
        state.visible = visible;
        this.setState({
            ...state
        },()=>{
            if(visible){
                this.getAccount();
            }
        })
    }

    handleImg(name,imgList=[]){
        this.setState({
            [name]:[].concat(imgList)
        });
    }

    successTip(){

    }

    /**
     * 校验必填
     * @return {boolean}
     */
    check(){

        const {showBuyerInput} = this.props;
        let state = this.state;
        if(
            (state.isAccurate&&state.fileIdList1.length==0&&state.fileIdList2.length==0)||
            (!state.isAccurate&&!state.subject&&state.fileIdList1.length==0&&state.fileIdList2.length==0)
        ){
            return false;
        }
        if(state.fileIdList1.length==0&&state.fileIdList2.length==0&&!state.subject){
            return false;
        }
        if(!state.purchaseQuantity){
            return false;
        }
        if(showBuyerInput&&!state.selectBuyerId){ // 如果显示客户选择框的，客户ID必填
            return false;
        }
        return true;
    }

    /**
     * 发布
     */
    onOk(){
        this.setState({
            verify:true,
            submitLoading:true
        },()=>{
            let state = {
                submitLoading:false
            }
            if(this.check()){
                const {showBuyerInput} = this.props;
                const { selectBuyerId } = this.state;
                var postData = {
                    priceMin:0,
                    priceMax:this.state.priceMax,
                    subject: this.state.subject||'',
                    isAccurate:this.state.isAccurate?1:0,
                    type:this.props.type,
                    fileIdList:[],
                    isNeedCertificate:this.state.isNeedCertificate?1:0,
                    purchaseQuantity:this.state.purchaseQuantity,
                    buyerId: showBuyerInput?selectBuyerId:this.props.buyerId,
                    buyerAccountId:this.state.buyerAccountId
                }
                if(this.state.fileIdList1.length>0){
                    this.state.fileIdList1.forEach((item)=>{
                        postData.fileIdList.push(item.fileId)
                    })
                }
                if(this.state.fileIdList2.length>0){
                    this.state.fileIdList2.forEach((item)=>{
                        postData.fileIdList.push(item.fileId)
                    })
                }

                request.post(
                    "/service/mg/fuzzy/submit",
                    postData
                )
                    .then((response) => {
                        const res = response.data;
                        if(res.success&&res.valid){
                            state.visible = false;
                            this.successTip();
                            if(typeof this.props.callback=='function'){
                                this.props.callback();
                            }
                        }
                        this.setState(state);
                    },()=>{
                        this.setState(state);
                    })
            }else{
                this.setState(state);
            }
        })
    }

    /**
     * 图片提示
     * @param text 提示语
     * @return {null|*}
     */
    tipImg(text){
        let state = this.state;
        if(
            (state.isAccurate&&state.fileIdList1.length==0&&state.fileIdList2.length==0)||
            (!state.isAccurate&&!state.subject&&state.fileIdList1.length==0&&state.fileIdList2.length==0)
        ){
            return <div className="color-danger">{text}</div>;
        }else{
            return null;
        }
    }

    /**
     * 提示描述
     * @return {null|*}
     */
    tipContent(){
        let state = this.state;
        if(
            state.fileIdList1.length==0&&state.fileIdList2.length==0&&!state.subject
        ){
            return <div className="color-danger mt_4">{Lang({id: "MiaoShuXuYaoZhaoDeShangPi2",default: "请输入描述"})}</div>;
        }else{
            return null;
        }
    }

    changeInput(name,decimalLen,e){
        let value = e.target.value;
        if(name=='priceMax'||name=='purchaseQuantity'){
            //去除非负号，0-9，小数点的数
            value = value.replace(/[^(0-9)(\.)]/gi,'');
            var list = value.split(".");
            if(list.length>0){
                var newValue = '';
                (list||[]).forEach((item,index)=>{
                    if(index==0){
                        newValue += item;
                        if(list.length>1){
                            newValue+='.';
                        }
                    }else if(index==1){
                        //保留2位小数
                        if(decimalLen>0){
                            item = item.substring(0,decimalLen);
                        }
                        newValue += item;
                    }
                })
                value = newValue;
            }
            if(decimalLen==0){
                //去除小数
                value = value.replace(/[^(\-)(0-9)]/gi,'');
            }
        }

        this.setState({
            [name]:value
        })
    }

    onBlurInput(name,max,e){
        let value = e.target.value;
        if(value){
            //处理 .123 和 123. 等情况
            value = Number(value);
            value = String(value);
        }
        if(value=='0'||isNaN(value)){
            this.setState({
                [name]:''
            })
        }else{
            if(Number(value)>max){
                value = max;
            }
            this.setState({
                [name]:value
            });
        }
    }

    changeCheck(name,e){
        this.setState({
            [name]:e.target.checked
        })
    }
    // 选择客户后回调行数据
    onChangeRow(dat={}){
        this.setState({
            selectBuyerId: dat.buyerId,
            tradeCurrencySymbol: dat.currencySymbol,
        })
        if(dat.buyerId){
            this.getAccount(dat.buyerId)
        }else {
            this.setState({
                accountSource:[],
                buyerAccountId: null,
                tradeCurrencySymbol: '',
            })
        }
    }
    getFormHtml(){
        const {showBuyerInput=false} = this.props;
        let {verify,selectBuyerId} = this.state;
        let accountValue = this.getAccountValue();
        return <div>
            <div className={"flex-item"}>
            {showBuyerInput&&<Form.Item className="box mb_0 inputNoBorder mr_8" style={{width:'50%'}}>
                <p className="color089 font_14 fw_700 mb_4 lineH_150p">
                    {Lang({id: "XuanZeKeHu",default: "选择客户"})}
                </p>
                <SearchSelector onRef={this.onRefFormSearch}
                                onChangeRow={(dat)=>this.onChangeRow(dat)}
                                title= {Lang({id: "KeHu",default: "客户",})}
                                searchField={'keyWord'}
                                api={'/service/mg/fin/ddp/remittance-item/buyerList'}
                                field = {[
                                    { cnTitle: '客户编号',cnTitleId:'KeHuBianHao', dataIndex:'buyerCode'},
                                    { cnTitle: '客户名称',cnTitleId:'KeHuMingCheng', dataIndex:'buyerName'},
                                    { title: 'ID',dataIndex:'buyerId'},
                                    { cnTitle: '所属国家',cnTitleId:'SuoShuGuoJia',dataIndex:'countryName'},
                                    { cnTitle: '交易货币',cnTitleId:'JiaoYiHuoBi',dataIndex:'currencySymbol'},
                                ]}
                                idField={'buyerId'} />
                {
                    (verify&&showBuyerInput&&!selectBuyerId)?
                        <div className="color-danger mt_4">
                            {Lang({id: "QingXuanZeKeHu",default: "请选择客户"})}
                        </div>
                        :
                        null
                }
            </Form.Item>}

            <Form.Item className="box mb_0 flex-1">
                <p className="color089 font_14 fw_700 mb_4 lineH_150p">
                    {Lang({id: "XuanZeZhangHao",default: "选择账号"})}
                </p>
                <Select labelInValue
                        {...accountValue}
                        optionFilterProp="children"
                        className="font_14"
                        size="large"
                        onChange={(item,option)=> {
                            this.setState({
                                buyerAccountId:item.value,
                                // tradeCurrencySymbol:option.props['data-symbol']
                            })
                        }}
                        placeholder={__getServerLanguage('QingXuanZeZhangHao')}>
                    {this.state.accountSource.map((item,index)=>{
                        return <Select.Option key={index}
                                              // data-symbol={item.tradeCurrencySymbol}
                                              value={item.buyAccountId}>
                            {/*{item.accountType=='m'?'BOSS ':`${item.name} `}*/}
                            {item.email}
                        </Select.Option>;
                    })}
                </Select>
            </Form.Item>
            </div>
            <div className="color066 font_14 lineH_150p mt_10">
                {Lang({id: "ZhiShaoShangChuanYiZhangT",default: "至少上传一张图片或填写说明"})}
            </div>
            <div className="mt_4 fuzzy-content__wrap">
                <div className="flex-item-ver-center color089 font_14 fw_500 mb_4 lineH_21">
                    <i className="color-danger mr_6">*</i>
                    <span>
                        {Lang({id: "ShangChuanShangPinTuPian",default: "上传商品图片"})}
                    </span>
                </div>
                <div className={"mt_4"}>
                    <Form.Item className="flex-1 mb_0">
                        <Input.TextArea maxLength={300}
                                        onChange={this.changeInput.bind(this,'subject',null)}
                                        value={this.state.subject}
                                        size="large"
                                        className="font_14"
                                        autoSize={{minRows: 6, maxRows: 6}}
                                        placeholder={Lang({id: "QingShuRuMiaoShuLiRuGongN",default: "请输入描述"})}></Input.TextArea>
                        {verify&&this.tipContent()}
                    </Form.Item>
                </div>
                <div className="mt_8 flex-item">
                    <Form.Item className="mr_12 mb_0 w100">
                        <UploadImg
                            accept={{
                                title: 'Images',
                                extensions: 'jpeg,jpg,png,bmp',
                            }}
                            fileSingleSizeLimit={20971520}
                            keyName={'fileIdList1'}
                            text={Lang({id: "ZhengMian",default: "正面"})}
                            showNum={false}
                            list={this.state.fileIdList1}
                            num={1}
                            onChange={this.handleImg.bind(this,'fileIdList1')}></UploadImg>
                        {verify&&this.tipImg(Lang({id: "QingShangChuanZhengMian",default: "请上传正面"}))}
                    </Form.Item>
                    <Form.Item className="mr_12 mb_0 w100">
                        <UploadImg
                            accept={{
                                title: 'Images',
                                extensions: 'jpeg,jpg,png,bmp',
                            }}
                            keyName={'fileIdList2'}
                            fileSingleSizeLimit={20971520}
                            text={Lang({id: "BeiMian",default: "背面"})}
                            showNum={false}
                            list={this.state.fileIdList2}
                            num={1}
                            onChange={this.handleImg.bind(this,'fileIdList2')}></UploadImg>
                        {verify&&this.tipImg(Lang({id: "QingShangChuanBeiMian",default: "请上传背面"}))}
                    </Form.Item>
                </div>
                <div className="flex-item-ver-center mb_0 mt_12">
                    <Checkbox className="color_FB7321"
                              onChange={this.changeCheck.bind(this,'isAccurate')}
                              checked={this.state.isAccurate}>{Lang({id: "BiXuYuTuPianShangPinYiZhi",default: "必须与图片商品一致"})}</Checkbox>
                </div>
            </div>
            <div className="box">
                <div>
                    <i className="color-danger mr_6">*</i>
                    <span className="color089 font_14 fw_700 mb_4 lineH_150p">
                        {Lang({id: "YuJiCaiGouLiang",default: "预计采购量"})}
                    </span>
                </div>
                <div className="color045 font_14 lineH_150p">{Lang({id:'QingTianXieZhenShiYuJiCai',default:'请填写真实预计采购量，如果数量差异太大，会出现价格差异、不满足最低起订量等情况'})}</div>
                <Input size="large"
                       className="w_272 font_14"
                       maxLength={7}
                       onChange={this.changeInput.bind(this,'purchaseQuantity',0)}
                       onBlur={this.onBlurInput.bind(this,'purchaseQuantity',9999999)}
                       value={this.state.purchaseQuantity}
                       placeholder={Lang({id: "QingShuRu",default: "请输入"})} addonAfter={Lang({id: "PCS",default: "PCS"})}/>
                {
                    (verify&&!this.state.purchaseQuantity)?
                        <div className="color-danger mt_4">
                            {Lang({id: "QingTianXieYuJiCaiGouLian",default: "请填写预计采购量"})}
                        </div>
                        :
                        null
                }
            </div>
            <div className="box">
                <Form.Item className="mb_0 inline-block">
                    <Checkbox className="color089 font_14 fw_700"
                              onChange={this.changeCheck.bind(this,'isNeedCertificate')}
                              checked={this.state.isNeedCertificate}>
                        <div className="font_14 lineH_18 fw_700 color089 mb_6">
                            {Lang({id: "ShangPinZhengShu",default: "商品证书"})}
                        </div>
                        <div className="color045 font_14">
                            {Lang({id: "BiXuDaiShangPinZhengShu",default: "必须带商品证书"})}
                        </div>
                    </Checkbox>
                </Form.Item>
            </div>

            <div className="box">
                <p className="color089 font_14 fw_700 mb_4 lineH_150p">
                    {Lang({id: "ShangPinJiaGeBuChaoGuo",default: "商品价格不超过"})}
                </p>
                <Input size="large"
                       className="w_272 font_14"
                       maxLength={11}
                       onChange={this.changeInput.bind(this,'priceMax',2)}
                       onBlur={this.onBlurInput.bind(this,'priceMax',99999999.99)}
                       value={this.state.priceMax}
                       placeholder={Lang({id: "QingShuRu",default: "请输入"})}
                       addonAfter={this.state.tradeCurrencySymbol}/>
            </div>
        </div>
    }

    /**
     * 获取当前选中的值
     * @param list
     * @param code
     * @return {{}}
     */
    getAccountValue(key){
        let value = {value:{key:'',label:__getServerLanguage('QingXuanZeZhangHao')}};
        (this.state.accountSource||[]).map( (item,index)=> {
            if(this.state.buyerAccountId){
                if(this.state.buyerAccountId==item.buyAccountId){
                    value = {value:{key:item.buyAccountId,label:item.email}};
                }
            }else{
                if(item.accountType=='m'){
                    value = {value:{key:item.buyAccountId,label:item.email}};
                }
            }

        })
        return value;
    }

    /**
     * 获取账号数据
     */
    getAccount(selectBuyerId){
        const {showBuyerInput,buyerId} = this.props;
        request.post(
                "/service/mg/follower/buyer/user-list",
                {
                    id: showBuyerInput?selectBuyerId:buyerId,// 如果是显示客户选择框的，即传选择框内的ID
                }
            )
            .then((response) => {
                const res = response.data;
                if(res.success&&res.valid){
                    let obj = {};
                    (res.models||[]).forEach(function (item) {
                        if(item.accountType=='m'){
                            obj = item;
                        }
                    })
                    this.setState({
                        accountSource:res.models||[],
                        buyerAccountId:obj.buyAccountId||null,
                        // tradeCurrencySymbol:obj.tradeCurrencySymbol||''
                    })
                }
            })
    }

    render(){
        if(this.props.isModal){
            return (
                <Fragment>
                    <span onClick={this.changeVisible.bind(this,true)}>
                        {this.props.children}
                    </span>
                    {
                        !this.props.isServer?
                            <Modal
                                destroyOnClose={true}
                                maskClosable={false}
                                open={this.state.visible}
                                width={700}
                                closable={false}
                                wrapClassName="special-modal release-fuzzy__wrap"
                                confirmLoading={this.state.submitLoading}
                                okText={Lang({id: "QueDing",default: "确定"})}
                                onOk={this.onOk.bind(this,false)}
                                cancelText={Lang({id: "QuXiao",default: "取消"})}
                                onCancel={this.changeVisible.bind(this,false)}>
                                <Form>
                                    <div className="color089 font_20 fw_700 lineH_150p">
                                        {Lang({id: "FaBuZhaoYang",default: "发布找样"})}
                                    </div>
                                    {this.getFormHtml()}
                                </Form>
                            </Modal>
                            :
                            null
                    }
                </Fragment>
            )
        }else{
            return (
                <div className="release-fuzzy__wrap content-fuzzy__wrap">
                    <Form>
                        <div className="color089 font_20 fw_700 lineH_150p">
                            {Lang({id: "FaBuZhaoYang",default: "发布找样"})}
                        </div>
                        {this.getFormHtml()}
                    </Form>
                    <div className="text-right">
                        <Button className="submit-fuzzy__btn"
                                onClick={this.onOk.bind(this,false)}
                                loading={this.state.submitLoading}
                                type="danger">
                            {Lang({id: "QueDing",default: "确定"})}
                        </Button>
                    </div>
                </div>
            )
        }

    }
}

ReleaseFuzzy.defaultProps = {
    isServer:false,
    //是否弹窗方式展示
    isModal:true,
    //必填，来源类型(10.搜索发起,20.以图搜图发起,30.直接新增发起,40.业务员代客户发起 50.业务员发起）
    type:30,
    currencySymbol:'',
    buyerId:null,
    showBuyerInput:false
}

ReleaseFuzzy.propTypes = {

}
export default ReleaseFuzzy;
